import * as React from "react"

function SendButton(props) {
  return (
    <svg viewBox="0 0 477.867 477.867" {...props}>
      <path d="M238.933 0C106.974 0 0 106.974 0 238.933s106.974 238.933 238.933 238.933 238.933-106.974 238.933-238.933S370.893 0 238.933 0zm81.424 403.926c-6.167 7.128-16.945 7.907-24.073 1.739-.17-.147-.337-.298-.501-.451l-170.667-153.6c-7.003-6.309-7.566-17.1-1.258-24.103.397-.441.817-.861 1.258-1.258l170.667-153.6c6.879-6.444 17.679-6.092 24.123.787 6.444 6.879 6.092 17.679-.787 24.123-.164.154-.331.304-.501.451L162.133 238.933l156.484 140.919c7.129 6.168 7.907 16.946 1.74 24.074z" />
    </svg>
  )
}

export default SendButton
